import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadStoreStatus, WriteStoreStatus } from "@/types/storeStatus";

export const storeStatusService = new APIService<
  ReadStoreStatus,
  WriteStoreStatus
>(API.StoreStatuses);

export const StoreStatusService = {
  // Temporary solution to get the statuses
  // API returns array of strings, but we need to return array of objects
  getList: async (fetchParams?: FetchListRequest<ReadStoreStatus>) => {
    const statuses = await storeStatusService.getList<string[]>(fetchParams);
    const items = statuses.map((status) => ({
      name: status,
      id: status,
    }));
    return {
      items,
      count: items.length,
    };
  },
};
